"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var client_and_facility_status_1 = require("../models/client-and-facility-status");
var calculators_1 = require("./calculators");
var enums_1 = require("./enums");
var moment_1 = __importDefault(require("moment"));
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.isObjectEmpty = function (obj) {
        return Object.keys(obj).length === 0;
    };
    // returns a number formatted into a shorter syntax.
    // example: 5000 becomes 5k, 50100 becomes 50.1k, 5120000 becomes 5.12m.
    // Does not work on numbers < 1000. Input only numbers > 1000.
    Utils.abbreviateNum = function (number, decPlaces) {
        if (decPlaces === void 0) { decPlaces = 2; }
        // 2 decimal places => 100, 3 => 1000, etc
        var strNum = "";
        decPlaces = Math.pow(10, decPlaces);
        // Enumerate number abbreviations
        var abbrev = ["k", "m", "b", "t"];
        // Go through the array backwards, so we do the largest first
        for (var i = abbrev.length - 1; i >= 0; i--) {
            // Convert array index to "1000", "1000000", etc
            var size = Math.pow(10, (i + 1) * 3);
            // If the number is bigger or equal do the abbreviation
            if (size <= number) {
                // Here, we multiply by decPlaces, round, and then divide by decPlaces.
                // This gives us nice rounding to a particular decimal place.
                number = Math.round((number * decPlaces) / size) / decPlaces;
                // Handle special case where we round up to the next abbreviation
                if (number === 1000 && i < abbrev.length - 1) {
                    number = 1;
                    i++;
                }
                // Add the letter for the abbreviation
                //  let strNum = number.toString() += abbrev[]
                strNum = "" + number + abbrev[i];
                // We are done... stop
                break;
            }
        }
        return strNum;
    };
    // Array must have a key called 'sortOrder'
    Utils.sortBySortOrder = function (array) {
        return array.sort(function (a, b) {
            if (a.sortOrder < b.sortOrder) {
                return -1;
            }
            else if (a.sortOrder > b.sortOrder) {
                return 1;
            }
            else {
                return 0;
            }
        });
    };
    Utils.sortAlphabetically = function (data, keyToSort) {
        return data.sort(function (a, b) {
            if (a[keyToSort].toLowerCase() < b[keyToSort].toLowerCase()) {
                return -1;
            }
            if (a[keyToSort].toLowerCase() > b[keyToSort].toLowerCase()) {
                return 1;
            }
            return 0;
        });
    };
    Utils.sortByNumber = function (data, keyToSort) {
        return data.sort(function (a, b) {
            if (a[keyToSort] < b[keyToSort]) {
                return -1;
            }
            if (a[keyToSort] > b[keyToSort]) {
                return 1;
            }
            return 0;
        });
    };
    Utils.arrayToString = function (array, keyValue, formatter) {
        var resultString = "";
        var enumKey = Object.keys(enums_1.clipboardKeys)[Object.values(enums_1.clipboardKeys).indexOf(keyValue)];
        array && ((array === null || array === void 0 ? void 0 : array.length) > 0) && array.forEach(function (e, index) {
            var value = e[enumKey];
            if (!value)
                value = "";
            switch (formatter) {
                case enums_1.formats.usd:
                    value = (0, calculators_1.formatNumberToUSD)(Number(value));
                    break;
                case enums_1.formats.percentage:
                    if (e.coinsuranceType === "$") {
                        value = (0, calculators_1.formatNumberToUSD)(Number(value));
                    }
                    else if (value) {
                        value += "%";
                    }
                    break;
                default:
                    break;
            }
            resultString += "".concat(keyValue, " ").concat(array.length > 1 ? index + 1 : "", ": ").concat(value, "\n");
        });
        return resultString;
    };
    Utils.objectToString = function (object, arrayInfo, optionalText) {
        var resultString = '';
        resultString += "".concat(optionalText, "\n\n");
        for (var _i = 0, _b = Object.entries(object); _i < _b.length; _i++) {
            var _c = _b[_i], key = _c[0], value = _c[1];
            var formattedKey = key.replaceAll("_", " ");
            resultString += "".concat(formattedKey, ": ").concat(value, "\n");
            if (key === "Patient_Financial_Responsibility") {
                // eslint-disable-next-line no-loop-func
                arrayInfo.forEach(function (e) {
                    resultString += e;
                });
                resultString += "Capacity to Pay Report\n";
            }
        }
        return resultString;
    };
    Utils.checkIfSelectedPayorIsGuarantor = function (payorId, patientAndChampionList) {
        var patientOrChampionToCheck = patientAndChampionList.find(function (champion) { return (champion.id === payorId); });
        return !!(patientOrChampionToCheck === null || patientOrChampionToCheck === void 0 ? void 0 : patientOrChampionToCheck.isGuarantor);
    };
    Utils.recentlyViewedAddVerificationClients = function (recentlyViewed, clientId) {
        if (!recentlyViewed.includes(clientId)) {
            recentlyViewed.unshift(clientId);
        }
        else {
            recentlyViewed.splice(recentlyViewed.indexOf(clientId), 1);
            recentlyViewed.unshift(clientId);
        }
        if (recentlyViewed.length > 4) {
            recentlyViewed.pop();
        }
        return recentlyViewed;
    };
    Utils.recentlyViewedAddVerificationPatients = function (recentlyViewedPatients, recentlyViewedPatient) {
        var isOnRecentlyViewed = recentlyViewedPatients.some(function (recentlyViewed) {
            if (recentlyViewed.patientId === recentlyViewedPatient.patientId &&
                recentlyViewed.encounterId === recentlyViewedPatient.encounterId) {
                return true;
            }
            else {
                return false;
            }
        });
        if (!isOnRecentlyViewed) {
            recentlyViewedPatients.unshift(recentlyViewedPatient);
        }
        else {
            var index = recentlyViewedPatients.findIndex(function (recentlyViewed) { return (recentlyViewed.patientId === recentlyViewedPatient.patientId &&
                recentlyViewed.encounterId === recentlyViewedPatient.encounterId); });
            recentlyViewedPatients.splice(index, 1);
            recentlyViewedPatients.unshift(recentlyViewedPatient);
        }
        if (recentlyViewedPatients.length > 4) {
            recentlyViewedPatients.pop();
        }
        return recentlyViewedPatients;
    };
    Utils.getPaymentTypeName = function (payment, hasDispute) {
        var _b, _c, _d, _e;
        var paymentType = hasDispute ? 'Unknown' : 'Unknown - Disputed';
        if (((_b = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _b === void 0 ? void 0 : _b.paymentTypeId) === 5 && (payment === null || payment === void 0 ? void 0 : payment.paymentAmt) === 0) {
            paymentType = "";
        }
        else if (((_c = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _c === void 0 ? void 0 : _c.paymentTypeId) === 5) {
            hasDispute ? paymentType = "At Facility - Disputed" : paymentType = "At Facility";
        }
        else if (payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) {
            if (hasDispute) {
                paymentType = (((_d = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _d === void 0 ? void 0 : _d.paymentMethodTypeId) === 1) ? "CC - Disputed" : "ACH - Disputed";
            }
            else {
                paymentType = (((_e = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _e === void 0 ? void 0 : _e.paymentMethodTypeId) === 1) ? "CC" : "ACH";
            }
        }
        return paymentType;
    };
    Utils.getTransactionType = function (payment) {
        var _b, _c;
        var paymentType = 'Unknown';
        if (((_b = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _b === void 0 ? void 0 : _b.paymentTypeId) === 5 && (payment === null || payment === void 0 ? void 0 : payment.paymentAmt) === 0) {
            paymentType = "";
        }
        else if ((_c = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _c === void 0 ? void 0 : _c.paymentTypeName) {
            paymentType = payment.paymentType.paymentTypeName;
        }
        return paymentType;
    };
    Utils.getTransactionDetails = function (payment) {
        var _b, _c, _d, _e, _f;
        var transactionDetails = "";
        if ((_b = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _b === void 0 ? void 0 : _b.cardPayment) {
            transactionDetails = "Ending in (".concat((((_c = payment.paymentMethodUsed) === null || _c === void 0 ? void 0 : _c.last4) || 'N/A'), ")");
        }
        else if ((((_d = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _d === void 0 ? void 0 : _d.paymentTypeId) === 5) && ((payment === null || payment === void 0 ? void 0 : payment.paymentAmt) === 0)) {
            transactionDetails = "";
        }
        else if (((_e = payment === null || payment === void 0 ? void 0 : payment.paymentType) === null || _e === void 0 ? void 0 : _e.paymentTypeId) === 5) {
            transactionDetails = 'Paid At Facility';
        }
        else {
            transactionDetails = "ACH \u25CF\u25CF\u25CF\u25CF\u25CF".concat((((_f = payment.paymentMethodUsed) === null || _f === void 0 ? void 0 : _f.last4) || ''));
        }
        return transactionDetails;
    };
    Utils.getStatusColor = function (statusCard) {
        var foundStatus = client_and_facility_status_1.clientFacilityStatus.find(function (status) {
            return status.status === statusCard.workflowSubStatus.subStatusName;
        });
        if (foundStatus) {
            return foundStatus.color;
        }
        else {
            return enums_1.StatusColors.gray;
        }
    };
    var _a;
    _a = Utils;
    Utils.convertBoolToYesNo = function (value) { return (value ? 'Yes' : 'No'); };
    Utils.convertDate = function (date) {
        if (date) {
            var convertedDate = date.toISOString().split("T")[0];
            if (convertedDate !== "1970-01-01") {
                return convertedDate;
            }
            else {
                return "0000-00-00";
            }
        }
        else {
            return "";
        }
    };
    Utils.convertISODate = function (date, details) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        var stringMinutes = '';
        var strTime = "";
        hours %= 12;
        hours = hours || 12;
        stringMinutes = minutes < 10 ? "0".concat(minutes.toString()) : minutes.toString();
        if (details) {
            strTime = "".concat(month, "/").concat(day, "/").concat(year, " ").concat(hours, ":").concat(stringMinutes, " ").concat(ampm);
        }
        else {
            strTime = "".concat(month, "/").concat(day, "/").concat(year);
        }
        return strTime;
    };
    Utils.getMinDate = function () { return (0, moment_1.default)('1900-01-01'); };
    Utils.getMaxDate = function () { return (0, moment_1.default)('2050-12-31'); };
    Utils.isValidDate = function (dateObject) {
        var from = _a.getMinDate();
        var to = _a.getMaxDate();
        if (dateObject === null) {
            return false;
        }
        if (!(0, moment_1.default)(dateObject).isBetween(from, to)) {
            return false;
        }
        return new Date(dateObject).toString() !== 'Invalid Date';
    };
    Utils.getDayOfWeekFromItsNumber = function (day) {
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][day];
    };
    Utils.trimFormFields = function (form) {
        for (var key in form) {
            if (typeof form[key] === "string") {
                var trimmed = form[key].toString().trim();
                form[key] = trimmed;
            }
        }
        return form;
    };
    Utils.deepClone = function (data) {
        return JSON.parse(JSON.stringify(data)) || [];
    };
    // Formatting a phone number to be ###-###-#### (no spaces, parentheses, etc)
    Utils.formatPhoneNumber = function (unformattedNumber) {
        var justNumbers = unformattedNumber.replace(/\D/g, "");
        // add first dash after you type 4th number
        if (justNumbers.length === 4) {
            var formattedNumber = justNumbers.replace(/(\d{3})(\d{1})/g, "$1-$2");
            return formattedNumber;
            // add second dash after you type 7th number
        }
        else if (justNumbers.length === 7) {
            var formattedNumber = justNumbers.replace(/(\d{3})(\d{3})(\d{1})/g, "$1-$2-$3");
            return formattedNumber;
            // add second dash on 10th number. Can happen if you copy/paste full number into field
        }
        if (justNumbers.length === 10) {
            var formattedNumber = justNumbers.replace(/(\d{3})(\d{3})(\d{4})/g, "$1-$2-$3");
            return formattedNumber;
        }
        else {
            return unformattedNumber;
        }
    };
    // Formatting a social security number (SSN) number to be ###-##-####
    Utils.formatSSN = function (unformattedNumber) {
        var justNumbers = unformattedNumber.replace(/\D/g, "");
        if (justNumbers.length === 9) {
            var formattedNumber = justNumbers.replace(/(\d{3})(\d{2})(\d{4})/g, "$1-$2-$3");
            return formattedNumber;
        }
        else {
            return unformattedNumber;
        }
    };
    // Formatting a social security number (SSN) number to be ###-##-####
    Utils.formatTaxIdNumber = function (unformattedNumber) {
        var justNumbers = unformattedNumber.replace(/\D/g, "");
        if (justNumbers.length === 3) {
            var formattedNumber = justNumbers.replace(/(\d{2})(\d{1})/g, "$1-$2");
            return formattedNumber;
        }
        else if (justNumbers.length === 9) {
            var formattedNumber = justNumbers.replace(/(\d{2})(\d{7})/g, "$1-$2");
            return formattedNumber;
        }
        else {
            return unformattedNumber;
        }
    };
    Utils.setPositiveNegativeNumberTextColor = function (hasPositiveNegativeEndTextColor, number) {
        if (hasPositiveNegativeEndTextColor && number < 0) {
            return "negative-number";
        }
        else if (hasPositiveNegativeEndTextColor && number > 0) {
            return "positive-number";
        }
    };
    Utils.getPayorName = function (props) {
        var _b, _c, _d, _e;
        var patientId = props.patientId, payorId = props.payorId, selectedPatient = props.selectedPatient, selectedEncounter = props.selectedEncounter;
        if (((patientId === payorId) && (patientId === (selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.patientId))) || (!payorId)) { // this means that the patient is the name we need
            return "".concat((_b = selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.contact) === null || _b === void 0 ? void 0 : _b.firstName, " ").concat((_c = selectedPatient === null || selectedPatient === void 0 ? void 0 : selectedPatient.contact) === null || _c === void 0 ? void 0 : _c.lastName);
        }
        else { // the payor has the name. search through patient champions
            var patientChampions = selectedEncounter === null || selectedEncounter === void 0 ? void 0 : selectedEncounter.patientChampion;
            var patientName = '';
            if (patientChampions && (patientChampions === null || patientChampions === void 0 ? void 0 : patientChampions.length) > 0) {
                var champion = patientChampions === null || patientChampions === void 0 ? void 0 : patientChampions.find(function (patientChampion) { return (patientChampion.patientChampionId === payorId); });
                patientName = "".concat((_d = champion === null || champion === void 0 ? void 0 : champion.contact) === null || _d === void 0 ? void 0 : _d.firstName, " ").concat((_e = champion === null || champion === void 0 ? void 0 : champion.contact) === null || _e === void 0 ? void 0 : _e.lastName);
            }
            return patientName;
        }
    };
    Utils.getPayorId = function (patientId, patientChampions) {
        var payorId;
        if ((patientChampions === null || patientChampions === void 0 ? void 0 : patientChampions.length) > 0) {
            patientChampions.forEach(function (champion) {
                payorId = (champion === null || champion === void 0 ? void 0 : champion.isGuarantor) && (champion === null || champion === void 0 ? void 0 : champion.patientChampionId);
            });
        }
        else {
            payorId = patientId;
        }
        return payorId;
    };
    Utils.convertPaymentMethodToReadableInfo = function (source) {
        if (!(source && (source === null || source === void 0 ? void 0 : source.object))) {
            return '';
        }
        var result = "";
        if ((source === null || source === void 0 ? void 0 : source.object) === 'card') {
            result = "".concat(source === null || source === void 0 ? void 0 : source.name, "'s ").concat(source === null || source === void 0 ? void 0 : source.brand, " card ending in ").concat(source === null || source === void 0 ? void 0 : source.last4);
        }
        else if ((source === null || source === void 0 ? void 0 : source.object) === 'bank_account') {
            result = "".concat(source === null || source === void 0 ? void 0 : source.name, "'s bank account ending in ").concat(source === null || source === void 0 ? void 0 : source.last4);
        }
        return result;
    };
    Utils.getInfoForTransaction = function (transaction, paymentMethods) {
        if (paymentMethods) {
            return paymentMethods.find(function (paymentMethod) { var _b; return (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) === ((_b = transaction === null || transaction === void 0 ? void 0 : transaction.paymentMethodUsed) === null || _b === void 0 ? void 0 : _b.externalPaymentMethodId); });
        }
        else
            return {};
    };
    Utils.windowOpenCentered = function (url) {
        var width = window.innerWidth;
        var documentWidth = width / 2;
        var documentHeight = 1000;
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var systemZoom = width / window.screen.availWidth;
        var left = (width - documentWidth) / 2 / systemZoom + dualScreenLeft;
        window.open(url, "_blank", "\n      scrollbars=yes,\n      width=".concat(documentWidth / systemZoom, ",\n      height=").concat(documentHeight / systemZoom, ",\n      top=20,\n      left=").concat(left, "\n      "));
    };
    Utils.getExternalPaymentId = function (payment) {
        var _b, _c, _d, _e;
        var paymentId = ''; // for paid at facility type which doesn't have an external payment ID
        if ((_b = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _b === void 0 ? void 0 : _b.ach) {
            paymentId = ((_c = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _c === void 0 ? void 0 : _c.externalPaymentMethodId) || '';
        }
        else if ((_d = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _d === void 0 ? void 0 : _d.cardPayment) {
            paymentId = ((_e = payment === null || payment === void 0 ? void 0 : payment.paymentMethodUsed) === null || _e === void 0 ? void 0 : _e.externalPaymentId) || '';
        }
        return paymentId;
    };
    Utils.handleNumericValues = function (e) {
        var input = e.target.value;
        var regEx = /^[0-9]*([.][0-9]*)?$/;
        return regEx.test(input);
    };
    Utils.isPolicyActive = function (vobState) {
        var startDate = (0, moment_1.default)(vobState.policyBeginDate);
        var endDate = (0, moment_1.default)(vobState.policyEndDate);
        var todayDate = (0, moment_1.default)();
        return (vobState.activePolicy &&
            todayDate.isBetween(startDate, endDate, "days", "[]"));
    };
    Utils.formatNumberToUSD = function (num) {
        if (typeof num === 'number' && !isNaN(num)) {
            var formattedNum = (Math.abs(num)).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });
            if (num < 0) {
                formattedNum = "(" + formattedNum + ")";
            }
            return formattedNum;
        }
        else { // input was not a number. invalid input. return 0.
            return 0;
        }
    };
    Utils.getFacilityName = function (facilityId, facilities) {
        var facilityNm = "";
        var facilityItem = facilities === null || facilities === void 0 ? void 0 : facilities.flat().find(function (fac) { return (fac === null || fac === void 0 ? void 0 : fac.facilityId) === facilityId; });
        if (facilityItem) {
            facilityNm = facilityItem.facilityName;
        }
        return facilityNm;
    };
    return Utils;
}());
exports.Utils = Utils;
